export default __webpack_public_path__ + "static/media/viacerta-logo.5085a488.svg";